<template>
  <div class="filter-params px-2 py-1">
    <v-row dense>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.categoryId"
          :items="categorySortedList"
          dense
          hide-details
          clearable
          item-value="id"
          item-text="name"
          :placeholder="group === 'entrant' ? 'Факультет' : 'Подразделение'"
          @click:clear="clearTableOptionsFiled(['pupilGroupId', 'pupilCourse'])"
        />
      </v-col>

      <v-col v-if="group === 'entrant'" cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.pupilCourse"
          :items="courses"
          dense
          hide-details
          clearable
          item-value="id"
          item-text="name"
          placeholder="Курс / Класс"
          :disabled="!tableOptions.categoryId"
          @click:clear="clearTableOptionsFiled(['pupilGroupId'])"
        />
      </v-col>

      <v-col v-if="group === 'entrant'" cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.pupilGroupId"
          :items="groupNames"
          :item-text="el => (el.liter ? el.liter : '-')"
          item-value="id"
          return-
          dense
          hide-details
          clearable
          placeholder="Группа / Литер"
          :disabled="!tableOptions.pupilCourse"
        />
      </v-col>

      <v-col v-if="enableRating" cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.ratingRequestStatus"
          :items="ratingStatuses"
          :item-text="el => el.description"
          item-value="name"
          return-
          dense
          hide-details
          clearable
          placeholder="Рейтинговая стипендия"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.validated"
          :items="validItems"
          clearable
          dense
          hide-details
          placeholder="Валидация"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="tableOptions.archival"
          :items="archiveItems"
          clearable
          dense
          hide-details
          placeholder="Архив"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { session, getManagement } from "@/services/session.service";
import { isAvailableModule } from "@/services/systemConfig.service";

export default {
  props: {
    group: {
      type: String,
      default() {
        return "null";
      }
    },
    tableOptions: {
      type: Object
    },
    categories: {
      type: Array
    },
    courses: {
      type: Array
    },
    groupNames: {
      type: Array
    },
    ratingStatuses: {
      type: Array
    }
  },
  data: () => ({
    validItems: [
      { text: "Требуют валидации", value: false },
      { text: "Валидные", value: true }
    ],
    archiveItems: [
      { text: "Не в архиве", value: false },
      { text: "В архиве", value: true }
    ]
  }),
  methods: {
    getManagement,
    clearTableOptionsFiled(fields = []) {
      fields.forEach(field => (this.tableOptions[field] = null));
    }
  },
  computed: {
    enableRating() {
      return (
        isAvailableModule("rating") &&
        this.group.toUpperCase() == "ENTRANT" &&
        session.permission.isAllow("tabs", "rating_request")
      );
    },

    categorySortedList() {
      return (getManagement(this.group) || this.categories).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
  }
};
</script>
